/* ---------------------------------------------------------------------------
   MF MENGE-HINTS (2026-09-08)
   ---------------------------------------------------------------------------
   Zeigt an der Mengen-Option "★ Beliebteste" und "spare X %" — identisch zur
   Produktseite, aber zusätzlich im Quick-Buy-Drawer ("In den Warenkorb" auf
   Produktkarten), der seinen Inhalt erst per Fetch nachlädt.

   Warum ein globales Asset:
   - Der PDP-Code liegt als Inline-Block in templates/product.json und wird nur
     auf der Produktseite gerendert. Der Quick-Buy-Drawer rendert nur die
     Blocktypen variant_picker / buy_buttons / @app -> Inline-Block fehlt dort.
   - Dieses Asset arbeitet pro <variant-picker> (scoped, nicht global) und
     reagiert per MutationObserver auf nachgeladene Drawer-Inhalte.
   - Es ist idempotent: laeuft es auf der PDP zusaetzlich zum Inline-Block,
     entsteht kein Doppel-Badge (bestehende Pills werden wiederverwendet).

   Sicherungen gegen Unsinn bei Nicht-Mengen-Optionen:
   - Option 1 muss exakt "Menge" heissen (getrimmt/lowercase). Damit faellt
     z. B. "Größe/Menge" (Twisted Glasfilter: "8 mm", "3er Set") raus.
   - Alle Optionswerte muessen als Stueckzahl lesbar sein ("250", "4er Set").
--------------------------------------------------------------------------- */
(function () {
  'use strict';

  var MENGE_POS = 1;                                   // Position der Mengen-Option
  var BELIEBT   = window.MF_MENGE_BELIEBT || '250';    // Menge mit "Beliebteste"-Badge
  var MIN_SAVE  = 3;                                   // ab X % wird "spare" gezeigt
  var OPTION_NAMES = ['menge'];                        // erlaubte Namen der Option 1

  /* ---------- CSS (einmalig, identisch zur Produktseite) ---------- */
  function injectCss() {
    if (document.getElementById('mf-menge-hints-css')) return;
    var s = document.createElement('style');
    s.id = 'mf-menge-hints-css';
    s.textContent = [
      '.mf-has-menge-hints .scroll-area,',
      '.mf-has-menge-hints .variant-picker__option-values{ padding-bottom:4px; }',
      '.vp-item--hint{ position:relative; padding-top:15px; }',
      '.vp-item--hint .mf-pill-hot{',
      '  position:absolute; top:0; left:50%; transform:translateX(-50%); z-index:4;',
      '  white-space:nowrap; font-size:10px; font-weight:600; letter-spacing:.02em;',
      '  padding:2px 8px; border-radius:999px; background:#6A00FF; color:#fff;',
      '  box-shadow:0 1px 4px rgba(106,0,255,.35);',
      '}',
      '.vp-item--hint .mf-pill-save{',
      '  display:block; margin-top:6px; text-align:center;',
      '  font-size:11.5px; font-weight:600; line-height:1.2;',
      '  padding:2px 6px; border-radius:6px; background:#e5f7ec; color:#00792f; white-space:nowrap;',
      '}',
      /* Drawer: Badge sitzt absolut ueber der Pill -> Platz schaffen, damit es
         nicht am oberen Rand der Scroll-Flaeche abgeschnitten wird. */
      '.quick-buy-drawer__info .mf-has-menge-hints .scroll-area{ overflow-y:visible; }',
      '.mf-spare-bezug{ margin:6px 0 0; font-size:12px; line-height:1.35; color:rgb(var(--text-color, 26 26 26) / .7); }'
    ].join('\n');
    (document.head || document.documentElement).appendChild(s);
  }

  /* ---------- Helfer ---------- */

  // "250" -> 250 · "4er Set" -> 4 · "8 mm" -> null · "MIXED" -> null
  function toMenge(value) {
    if (value == null) return null;
    var v = String(value).trim();
    var m = v.match(/^(\d+)$/) || v.match(/^(\d+)\s*er\b/i);
    return m ? parseInt(m[1], 10) : null;
  }

  // Optionsname aus dem <legend> des zugehoerigen fieldset (z. B. "Menge:")
  function optionNameOf(fieldset) {
    // AUDIT Paket A (28.09.2026): Die Legende zeigt auf deutschen Seiten "Packungsgröße" statt "Menge".
    // Der echte Optionsname steht deshalb in data-option-name (snippets/variant-picker.liquid).
    var dn = fieldset && fieldset.getAttribute('data-option-name');
    if (dn) return dn.trim().toLowerCase();
    var legend = fieldset && fieldset.querySelector('legend');
    if (!legend) return '';
    return legend.textContent.replace(/:/g, '').trim().toLowerCase();
  }

  /* ---------- Kernlogik pro <variant-picker> ---------- */
  function process(picker) {
    var dataEl = picker.querySelector('script[data-variants]');
    if (!dataEl) return;

    var variants;
    try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }
    if (!Array.isArray(variants) || !variants.length) return;

    var items = [].slice.call(
      picker.querySelectorAll('.vp-item[data-option-position="' + MENGE_POS + '"][data-option1]')
    );
    if (items.length < 2) return;

    // Nur echte Mengen-Optionen
    var fieldset = items[0].closest('fieldset');
    if (OPTION_NAMES.indexOf(optionNameOf(fieldset)) === -1) return;

    // Alle Werte muessen als Stueckzahl lesbar sein
    var mengen = items.map(function (it) { return toMenge(it.getAttribute('data-option1')); });
    if (mengen.some(function (m) { return !m || m <= 0; })) return;

    var mengeIdx = MENGE_POS - 1;
    var nOpts = ((variants[0] || {}).options || []).length;
    var colorIdx = -1;
    for (var i = 0; i < nOpts; i++) { if (i !== mengeIdx) { colorIdx = i; break; } }

    // Referenzfarbe = aktuell gewaehlte Variante dieses Pickers
    var refColor = null;
    if (colorIdx >= 0) {
      var formId = picker.getAttribute('form-id');
      var idInput = null;
      if (formId) {
        idInput = document.querySelector('[name="id"][form="' + formId + '"]');
        var formEl = document.getElementById(formId);
        if (!idInput && formEl) idInput = formEl.querySelector('[name="id"]');
      }
      if (!idInput) {
        var scope = picker.closest('product-rerender, product-form, .shopify-section, body');
        if (scope) idInput = scope.querySelector('form[action*="/cart/add"] [name="id"]');
      }
      var sv = idInput ? variants.filter(function (v) { return String(v.id) === String(idInput.value); })[0] : null;
      if (!sv) sv = variants.filter(function (v) { return v.available; })[0] || variants[0];
      refColor = (sv.options || [])[colorIdx];
    }

    // Preis pro Stueck fuer eine Menge (bevorzugt in der Referenzfarbe)
    function ppu(rawValue) {
      var m = toMenge(rawValue);
      if (!m) return null;
      var match = function (x) { return String((x.options || [])[mengeIdx]) === String(rawValue); };
      var v = variants.filter(function (x) {
        var ok = match(x);
        if (ok && colorIdx >= 0 && refColor != null) ok = (x.options || [])[colorIdx] === refColor;
        return ok;
      })[0];
      if (!v) v = variants.filter(match)[0];
      if (!v || typeof v.price !== 'number') return null;
      return v.price / m;
    }

    // Referenz = kleinste Menge
    var refIdx = 0;
    for (var k = 1; k < mengen.length; k++) { if (mengen[k] < mengen[refIdx]) refIdx = k; }
    var refPpu = ppu(items[refIdx].getAttribute('data-option1'));

    if (fieldset) fieldset.classList.add('mf-has-menge-hints');

    items.forEach(function (it) {
      var val = it.getAttribute('data-option1');
      if (!val) return;
      it.classList.add('vp-item--hint');

      var oldHot  = it.querySelector('.mf-pill-hot');
      var oldSave = it.querySelector('.mf-pill-save');

      var wantHot = (BELIEBT && String(val) === String(BELIEBT));
      if (wantHot && !oldHot) {
        var h = document.createElement('span');
        h.className = 'mf-pill-hot';
        h.textContent = '★ Beliebteste';
        it.appendChild(h);
      } else if (!wantHot && oldHot) {
        oldHot.remove();
      }

      var p = ppu(val);
      var pct = (refPpu && p && p < refPpu) ? Math.round((refPpu - p) / refPpu * 100) : 0;
      if (pct >= MIN_SAVE) {
        var html = 'spare ' + pct + '&nbsp;%';
        if (oldSave) { if (oldSave.innerHTML !== html) oldSave.innerHTML = html; }
        else {
          var s = document.createElement('span');
          s.className = 'mf-pill-save';
          s.innerHTML = html;
          it.appendChild(s);
        }
      } else if (oldSave) {
        oldSave.remove();
      }
    });

    // AUDIT R2-T2 (29.09.2026, p-187 INFO-02, p-flow INFO-01): Bezugsbasis der "spare X %"-Hinweise einmal unter den Pills nennen
    // (Preis je Stück gegenüber der kleinsten Packung). Nur Anzeige, Beträge unverändert; ohne Spar-Hinweis keine Zeile.
    var valuesEl = items[0].closest('.variant-picker__option-values');
    var host = valuesEl && valuesEl.parentElement;
    var hatSave = items.some(function (it) { return !!it.querySelector('.mf-pill-save'); });
    var note = fieldset ? fieldset.querySelector('.mf-spare-bezug') : null;
    if (hatSave && host) {
      var refBtn = items[refIdx].querySelector('.block-swatch, label, a');
      var refText = (refBtn ? refBtn.textContent : items[refIdx].getAttribute('data-option1') || '').replace(/\s+/g, ' ').trim();
      refText = refText.replace(/★.*$/, '').replace(/spare.*$/i, '').trim();
      // AUDIT 2026-11 pdp AV-07: Statuszusatz der Packung (z. B. "1 Heft – Ausverkauft") gehört nicht in den Erklärsatz
      refText = refText.replace(/\s*[–—-]?\s*\(?\s*(ausverkauft|sold out|esaurito|épuisé|epuise)\s*\)?\s*$/i, '').trim();
      var txt = 'Ersparnis je Stück gegenüber der kleinsten Packung (' + refText + ')';
      if (!note) {
        note = document.createElement('p');
        note.className = 'mf-spare-bezug';
        host.parentNode.insertBefore(note, host.nextSibling);
      }
      if (note.textContent !== txt) note.textContent = txt;
    } else if (note) {
      note.remove();
    }
  }

  /* ---------- Scan + Observer ---------- */
  var observer = null;

  function scan() {
    injectCss();
    if (observer) observer.disconnect();          // eigene DOM-Writes nicht beobachten
    try {
      [].slice.call(document.querySelectorAll('variant-picker')).forEach(process);
    } catch (e) { /* nie die Seite blockieren */ }
    if (observer) observer.observe(document.body, { childList: true, subtree: true });
  }

  var timer = null;
  function scanSoon(delay) {
    clearTimeout(timer);
    timer = setTimeout(scan, delay || 60);
  }

  function start() {
    injectCss();
    scan();

    observer = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var added = mutations[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          var n = added[j];
          if (n.nodeType !== 1) continue;
          if (n.matches && (n.matches('variant-picker') || n.matches('product-rerender'))) { scanSoon(); return; }
          if (n.querySelector && n.querySelector('variant-picker')) { scanSoon(); return; }
        }
      }
    });
    observer.observe(document.body, { childList: true, subtree: true });

    // Variantenwechsel (Menge/Farbe) neu bewerten
    document.addEventListener('change', function (e) {
      if (e.target && e.target.closest && e.target.closest('variant-picker')) scanSoon(80);
    });

    // Drawer-Oeffnen: Theme rendert asynchron nach
    document.addEventListener('click', function (e) {
      if (e.target && e.target.closest && e.target.closest('[aria-controls*="quick-buy"]')) {
        scanSoon(150); setTimeout(scan, 600); setTimeout(scan, 1200);
      }
    }, true);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
